<template>
	<div>
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="ibox-content">
				<div class="row">
					<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="search()" v-if="!loading">

							<div class="row form-group middleZindx">
								<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">From
									date:</span>
								<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
									<input type="text" name="fromDate" id="fromDate" v-model="fromDate">
									<small class="ml-3">(Optional, format: 2023-06-14)</small>
								</div>
							</div>

							<div class="row form-group middleZindx">
								<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">To
									date:</span>
								<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
									<input type="text" name="toDate" id="toDate" v-model="toDate">
									<small class="ml-3">(Optional, format: 2023-06-14)</small>
								</div>
							</div>

							<div class="row form-group topZindex">
								<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label importantColor">From
									number:</span>
								<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
									<input type="text" name="fromNumber" id="fromNumber" v-model="fromNumber">
									<small class="ml-3">(Optional)</small>
								</div>
							</div>

							<div class="row form-group middleZindx">
								<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">To number:</span>
								<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
									<input type="text" name="toNumber" id="toNumber" v-model="toNumber">
									<small class="ml-3">(Optional)</small>
								</div>
							</div>

							<div class="row form-group middleZindx">
								<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">Content:</span>
								<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
									<input type="text" name="content" id="toNumber" v-model="content">
									<small class="ml-3">(Optional)</small>
								</div>
							</div>

							<hr>
							<div class="row submit-button-container">
								<button type="submit" :disabled="sendInProgress || !fromDate || !toDate" ref="submitbtn"
									class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt"
									data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white"
									style="display: block;">
									<span class="ladda-label">Search</span>
									<span class="fas fa-spinner fa-pulse"></span>
									<div class="ladda-progress" style="width: 0px"></div>
								</button>
							</div>
						</form>
					</div>
				</div>
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;"
					ng-if="options.showProgress">
					<div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope" ng-if="options.showProgress"
						style="display: block;">
						<div class="sk-rect1"></div>
						<div class="sk-rect2"></div>
						<div class="sk-rect3"></div>
						<div class="sk-rect4"></div>
						<div class="sk-rect5"></div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox float-e-margins">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding: 0px;">
							<div class="table-filter-wrapper filterContainer">
								<input v-model="filterText" id="incomingsms-table-filter" type="text"
									name="incomingsms_filter" placeholder="Filter" autocomplete="incomingsms_filter">
								<img ng-click="focusInput()" src="/pbx2/assets/images/panel/search.svg">
							</div>
						</div>
						<div class="ibox-title">
							<h4 v-if="items && items.length">
								Incoming Sms History 1 to {{ items.length }} of
								{{ items.length }}
							</h4>
						</div>
						<div class="ibox-content">
							<Loading v-if="loading" />
							<table class="table footable table-stripped footable-loaded" v-if="!loading">
								<thead>
									<tr>
										<th>From Number</th>
										<th>To Number</th>
										<th>Date</th>
										<th>Content</th>
									</tr>
								</thead>
								<tbody>
									<tr class="gradeX" v-for="(incomingRecord) in filteredEvents"
										v-bind:key="incomingRecord.key" data-index="0" style="display: table-row">
										<td>
											{{ incomingRecord.snumber }}
										</td>
										<td>
											{{ incomingRecord.dnumber }}
										</td>
										<td>
											{{ incomingRecord.timestamp }}
										</td>
										<td>
											{{ incomingRecord.content }}
										</td>
									</tr>
								</tbody>
								<tfoot>
									<td colspan="2">
										<button class="btn btn-sm btn-success" @click="exportCsv()">
											Export CSV
										</button>
									</td>
								</tfoot>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {IncomingSMSCdrApiService} from "../../services/IncomingSMSCdrApiService";
import Loading from "../../components/Loading";
import {uuid} from "vue-uuid";
export default {
	data: () => ({
		loading: false,
		sendInProgress: false,
		items: [],
		headers: ["snumber", "dnumber", "timestamp", "content"],
		images: null,
		filterText: "",
		numbersData: [],
		fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split("T")[0],
		toDate: new Date().toISOString().split("T")[0],
		fromNumber: null,
		toNumber: null,
		content: null
	}),
	components: {Loading},
	created() {
		let $injector = this.$root.angularInjector;
		let CoreApiService = $injector.get("CoreApiService");
		this.SwalService = $injector.get("SwalService");
		this.IncomingSMSCdrApiService = new IncomingSMSCdrApiService(CoreApiService);
	},
	async mounted() {
		this.search();
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	computed: {
		filteredEvents() {
			if (this.filterText.length >= 2) {
				return this.items.filter(item => item.number.includes(this.filterText) || item.email.includes(this.filterText));
			}
			return this.items;
		}
	},
	methods: {
		csvToJson(csv) {
			let lines = csv.split("\n");
			let result = [];
			let headers = lines[0].split(",");
			for (var i = 1; i < lines.length; i++) {
				let obj = {};
				let currentline = lines[i].split(",");
				for (var j = 0; j < headers.length; j++) {
					obj[headers[j]] = currentline[j];
				}
				result.push(obj);
			}
			return JSON.stringify(result);
		},
		async exportCsv() {
			this.loading = true;
			this.allIncomingSMS = await this.IncomingSMSCdrApiService.search({fromDate: this.fromDate || "2023-06-01", toDate: this.toDate || "2023-06-14", snumber: this.fromNumber, dnumber: this.toNumber, content: this.content});
			const rowsData = this.allIncomingSMS.map(row => [this.headers.map(title => row[title])]);
			const rows = [
				this.headers,
				...rowsData
			];
			let csvContent = "data:text/csv;charset=utf-16;";

			rows.forEach(function(rowArray) {
				let row = rowArray.join(",");
				csvContent += row + "\r\n";
			});

			const data = encodeURI(csvContent);
			const link = document.createElement("a");
			link.setAttribute("href", data);
			link.setAttribute("download", "export.csv");
			link.click();
			this.loading = false;
		},
		async search() {
			this.loading = true;
			this.items = await this.IncomingSMSCdrApiService.search({fromDate: this.fromDate || "2023-06-01", toDate: this.toDate || "2023-06-14", snumber: this.fromNumber, dnumber: this.toNumber, content: this.content});
			this.items = this.items.map(item => {
				item.key = uuid.v4();
				return item;
			});
			this.loading = false;
		}
	}
};
</script>

<style scoped>
.boldRed {
	color: rgb(255, 0, 0);
	font-weight: 700;
}

.lineThrough {
	text-decoration: line-through;
}

.deleted {
	color: red;
}

.expiredGreyOut {
	opacity: 0.25;
}

.dNone {
	display: none;
}

.filterContainer {
	position: absolute;
	top: 18px;
	right: 18px;
}
</style>